require("./save-search.scss");

import SaveSearchRenderer from "./save-search-renderer";

(function ($, data) {

    $(function () {
        new SaveSearchRenderer($(".save-search").get(0), data).render();
    });

})(jQuery, window.saved_search_data);